import 'babel-polyfill'
//
// import {without, throttle, debounce} from 'lodash'
// import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'

import './selects'
import './content'
import './load-more'
import './front-page'
import './header'
import './jaotama'
import './sponsor-strip'

import './sports'

import './countdown'

import './ad-tracking'

import './secondary-nav'

import './tooltip'

import './news'

import './game'

import './announcement'

import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import './accordion'

import './newsletter-popup'

// jQuery('.content iframe').reframe()

jQuery(document).ready(function () {
    Fancybox.bind('[data-fancybox]', {
        //
    });
});
